var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Model from './Model';
/**
 *
 */
var InitialManualAssetModel = /** @class */ (function (_super) {
    __extends(InitialManualAssetModel, _super);
    /**
     *
     * @param data
     */
    function InitialManualAssetModel(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data) || this;
        _this.emissionClass = null;
        _this.nominalPower = null;
        _this.fuelType = null;
        _this.initialCumulativeOperatingHoursValue = {
            timestamp: null,
            value: null
        };
        _this.initialFuelUsedInLiters = {
            timestamp: null,
            value: null
        };
        _this.initialLocation = {
            latitude: null,
            longitude: null,
            altitudeInMeters: null,
            timestamp: null
        };
        return _this;
    }
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "equipmentId", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "serialNumber", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "make", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "model", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "iconName", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "iconColor", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "iconColorRgba", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "emissionClass", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "nominalPower", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "fuelType", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "initialCumulativeOperatingHoursValue", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "initialFuelUsedInLiters", void 0);
    __decorate([
        observable
    ], InitialManualAssetModel.prototype, "initialLocation", void 0);
    return InitialManualAssetModel;
}(Model));
export default InitialManualAssetModel;
